import React, { useEffect, useState } from 'react';
import Bio from './home/Bio';
import Testimonials from './home/Testimonials';
import DogImageGallery from './ImageGallery';
import { trackEvent } from '../utils/matomoEvents';

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <h1>Welcome to Gator Skin Frenchies</h1>
        <p className="hero-tagline">Breeding French Bulldogs with Love and Care</p>
      </div>

      <style jsx>{`
        .hero {
          height: 30vh;
          background-image: url('/home_hero.jpg');
          background-size: cover;
          background-position: center 18%;
          background-repeat: no-repeat;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          position: relative;
        }

        .hero::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.4);
        }

        .hero-content {
          position: relative;
          z-index: 1;
          color: white;
          padding: 2rem;
        }

        .hero-tagline {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #fff;
          margin-bottom: 1.5rem;
        }

        h1 {
          font-size: 3.5rem;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1.5rem;
        }

        @media (max-width: 768px) {
          h1 {
            font-size: 2.5rem;
          }

          p {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </section>
  );
}

export default function Home() {
  const [homeImages, setHomeImages] = useState([]);

  useEffect(() => {
    fetch('/dog-photos/home-gallery/index.json')
      .then(response => response.json())
      .then(data => {
        const images = data.photos.map(photo => `/dog-photos/home-gallery/${photo}`);
        setHomeImages(images);
        // Track gallery load with image count
        trackEvent('Home', 'GalleryLoad', 'Previous Pups Gallery', images.length);
      })
      .catch(error => console.error('Error fetching home gallery images:', error));
  }, []);

  return (
    <div>
      <Hero />
      <Bio />
      <Testimonials />
      <section className="gallery-section">
        <h2>Our Previous Pups</h2>
        <DogImageGallery images={homeImages} showDogInfo={true} />
      </section>

      <style jsx>{`
        .gallery-section {
          max-width: 564px;
          margin: 2rem auto;
          padding: 2rem;
          background-color: var(--surface-alt);
          border-radius: 15px; /* Add rounded corners */
        }

        .gallery-section h2 {
          text-align: center;
          font-size: 2rem;
          color: var(--text);
          margin-bottom: 2rem;
        }

        .gallery-section img {
          object-fit: cover;
          width: 100%;
          height: 540px;
        }
      `}</style>
    </div>
  );
}